<template>
  <div>
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh;padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <iframe class="strategio-iframe" :src="url" frameborder="0"></iframe>
      </div>
    </v-main>
  </div>
</template>

<script>
import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'

export default {
  name: 'show-metabase',
  data () {
    return {
      url: 'https://helpdesk.vida.software'
    }
  },
  components: {
    StrategioAppBar
  }
}
</script>

<style>
.strategio-iframe {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/routes/show-helpdesk.vue